import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Footer as FooterComponent} from './Footer';

const manager = new I18nManager({locale: 'en-CA'});

function FooterSection(props) {
  return (
    <I18nContext.Provider value={manager}>
      <FooterComponent {...props} />
    </I18nContext.Provider>
  );
}

export default renderReact('Footer', FooterSection);
